import http from '../../../utils/fetch';
export default {
    query(instid) {
        return http({
            url: '/api/swyl/v1/infoCredit/userInfoCredit/checkCredit',
            method: 'post',
            params: {instid}
        });
    },
    approveCreate(v) {
        return http({
            url: '/api/swyl/v1/infoCredit/userInfoCredit/approveCreate',
            method: 'post',
            params: v
        });
    },
    getAgent(usercode) {
        return http({
            url: '/api/swyl/v1/basic/bscUserInfo/getAgent',
            method: 'post',
            params: {usercode}
        });
    },
}